import { Workbox } from "workbox-window";

let wb = null;

if ("serviceWorker" in navigator) {
    wb = new Workbox(`${process.env.BASE_URL}service-worker.js`);

    // وقتی یک سرویس‌ورکرِ جدید کنترل صفحه را می‌گیرد، یک‌بار رفرش می‌کنیم تا
    // نسخه‌ی تازه بارگذاری شود. این پرچم فقط جلوِ رفرشِ تکراری در همین
    // بارگذاریِ صفحه را می‌گیرد (اگر رویداد controlling چندبار در یک صفحه شلیک شود)؛
    // نباید در sessionStorage ماندگار شود، وگرنه بعد از اولین به‌روزرسانیِ موفق در
    // یک تب، هر دیپلویِ بعدیِ همان تب دیگر هرگز واقعاً رفرش نمی‌شود — سرویس‌ورکرِ
    // جدید فعال می‌شود اما باندلِ قدیمی همچنان در حافظه اجرا می‌ماند و پیامِ
    // «نسخه‌ی جدید آماده است» هر بار دوباره ظاهر می‌شود چون به‌روزرسانی هیچ‌وقت واقعاً کامل نشده.
    let reloading = false;

    wb.addEventListener("controlling", () => {
        if (reloading) return;
        reloading = true;
        window.location.reload();
    });

    wb.register().catch((err) => {
        // eslint-disable-next-line no-console
        console.warn("SW registration failed:", err && err.message);
    });
}

export default wb;
